import ClientAgentExtender from '../Common/clientAgentExtender'
import Storitev from './Storitev'

export default class Storitve extends ClientAgentExtender {
  _vklopljeneStoritve = null
  _naroceneStoritve = null
  _vrste = null
  _idPrikljucek = null

  constructor (vrste, idPrikljucek) {
    super()
    this._vrste = vrste
    this._idPrikljucek = idPrikljucek
  }

  async loadList (override = false) {
    if (this._vklopljeneStoritve === null || this._naroceneStoritve === null || override) {
      let tmpList = []
      let request = {
        idPrikljucek: this._idPrikljucek,
        idVrsta: this._vrste,
        idStatus: 1
      }
      let response = await this.ca.makeRequest('prikljucek/storitve/info', request, 'POST')
      response.seznamStoritev.forEach((s) => {
        tmpList.push(Storitev.parseFromResponseItem(s, 1))
      })
      this._vklopljeneStoritve = tmpList
      request.idStatus = 0
      response = await this.ca.makeRequest('prikljucek/storitve/info', request, 'POST')
      tmpList = []
      response.seznamStoritev.forEach((s) => {
        tmpList.push(Storitev.parseFromResponseItem(s, 0))
      })
      this._naroceneStoritve = tmpList
    }
  }
  getStoritevById (idStoritve, vklopljena = false, narocena = false) {
    let list = vklopljena ? this._vklopljeneStoritve : this._naroceneStoritve
    if (list !== null) {
      for (let i = 0; i < list.length; i++) {
        if (list[i].idStoritev === idStoritve) {
          return list[i]
        }
      }
    }
    return null
  }

  get vrste () {
    return this._vrste
  }

  set vrste (value) {
    this._vrste = value
  }

  get idPrikljucek () {
    return this._idPrikljucek
  }

  set idPrikljucek (value) {
    this._idPrikljucek = value
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/Storitve/Storitve.js